import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Modal,
  Menu,
  MenuItem,
  TextField,
  Button,
  IconButton,
  Select,
  FormControl,
  InputLabel,
  Input,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import { MoreVert, Clear, CloudUpload } from "@mui/icons-material";

import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";

import SnackbarComponent from "../../components/SnackBar/snackBar";



const initialCategories = ["Marketing", "Sales", "IT"];

export default function AdminListingCategory() {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const loginToken = useSelector((state) => state.user.logintoken);
  const [categoryNameError, setCategoryNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");

  const [vendors, setVendors] = useState();
  const [categories, setCategories] = useState(initialCategories);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isCategoryModal, setCategoryModal] = useState(false);
  const [search, setSearch] = useState("");

  const getInitialFormValues = () => ({
  
    category_id: selectedVendor ? selectedVendor.category_id : "",
    name: selectedVendor ? selectedVendor.name : "",
    description: selectedVendor ? selectedVendor.description : "",
    image_url: selectedVendor ? selectedVendor.image_url : "",
    status: selectedVendor ? selectedVendor.status : "",
    
   });

  // const [formValues, setFormValues] = useState({
  //   category: "",
  //   category_name: "",
  //   subCategory: "",
  //   image: null,
  //   description: "",
  //   name: "",
  //   status: 0,
  // });

  const [formValues, setFormValues] = useState(getInitialFormValues());

  const {
    data: listingDataData,
    isLoading: isListingDataLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllListing"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (error) {
    } else if (listingDataData && listingDataData["status"] === true) {
      console.log("categoryData", listingDataData["data"]);
      setVendors(listingDataData["data"]);
    }
  }, [listingDataData, error]);

  const {
    data: updatedCategoryData,
    isLoading: updatedCategoryLoading,
    error: updatedCategoryError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (updatedCategoryError) {
    } else if (updatedCategoryData && updatedCategoryData["status"] === true) {
      console.log("updatedCategoryData", updatedCategoryData["data"]);

      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedCategoryData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [updatedCategoryData, updatedCategoryError]);

  const {
    data: deletedCategoryData,
    isLoading: deletedCategoryLoading,
    error: deletedCategoryError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (deletedCategoryError) {
    } else if (deletedCategoryData && deletedCategoryData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: deletedCategoryData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      handleMenuClose();
      fetchData();
    }
  }, [deletedCategoryData, deletedCategoryError]);

  const {
    data: createCategoryData,
    isLoading: createCategoryLoading,
    error: createCategoryError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createListing"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (createCategoryError) {
    } else if (createCategoryData && createCategoryData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: createCategoryData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      fetchData();
    }
  }, [createCategoryData, createCategoryError]);

  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const filteredData = search
    ? vendors.filter(
        (item) =>
          item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.description.toLowerCase().includes(search.toLowerCase())
      )
    : vendors;

  const handleMenuClick = (event, vendor) => {
    setAnchorEl(event.currentTarget);
    setSelectedVendor(vendor);
    console.log("selectedvendor edit", vendor);
    setFormValues({
      name: vendor.name || "",
      description: vendor.description || "",
      image: vendor.imageurl || null, // Assuming 'imageurl' holds the image
      status: vendor.status !== undefined ? vendor.status : 0, // Ensure status is set
    });
  };



  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVendor(null);
  };

  const handleDelete = () => {
    // setVendors(vendors.filter((v) => v.sno !== selectedVendor.sno));
    const deleteUrl = urls("deleteCategories", selectedVendor["category_id"]);
    fetchDeleteData(deleteUrl);
  };

  const handleAddCategory = () => {
    //  .category && !categories.includes(formValues.category)
    if (formValues) {
      console.log("formValues", formValues);
      if (!formValues["name"]) {
        setCategoryNameError("Category name is required");
        return;
      } else if (!formValues["description"]) {
        setDescriptionError("Description  is required");
      } else {
        const formdata = new FormData();
        formdata.append("name", formValues["name"]);
        formdata.append("description", formValues["description"]);
        formdata.append("imageurl", formValues["image"]);

        fetchCreateData(formdata);
        setModalOpen(false);
        setFormValues(getInitialFormValues());
      }
    }
  };

  const handleAddSubCategory = () => {
    if (formValues.category.length && formValues.subCategory) {
      setVendors([
        ...vendors,
        {
          sno: vendors.length + 1,
          category: formValues.category,
          subCategory: formValues.subCategory,
          image: formValues.image,
          description: formValues.description,
        },
      ]);
    }
    setModalOpen(false);
    setFormValues(getInitialFormValues());
  };

  const handleEdit = () => {
    console.log("formValuesCat", formValues, formValues["status"]);

    const formdata = new FormData();
    formdata.append("name", formValues["name"]);

    formdata.append("description", formValues["description"]);
    formdata.append("imageurl", formValues["image"]);
    formdata.append("status", formValues["status"] ? formValues["status"] : 0);
    const updateUrl = urls("updateListing", selectedVendor["category_id"]);
    fetchUpdateData(updateUrl, formdata);

    setModalOpen(false);
    handleMenuClose();
    setFormValues({
      category: "",
      subCategory: "",
      image: null,
      description: "",
      name: "",
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFileChange = (e) => {
    // const file = e.target.files[0];
    const file = e.target.files[0];
    console.log("file", file);
    setFormValues({ ...formValues, image: file });
  };

  const handleCloseModal = () => {
    setCategoryModal(false);
    setModalOpen(false);
    setFormValues({
      category: [],
      subCategory: "",
      image: null,
      description: "",
    });
    setSelectedVendor(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };



  return (
    <Box sx={{ padding: 3, backgroundColor: "#F9FAFC" }}>
      <SnackbarComponent
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        severity={snackbarState.severity}
        message={snackbarState.message}
        position={snackbarState.position}
      />
      {/* Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          borderRadius: "20px",
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{
            width: "30%",
            backgroundColor: "#FFF",
            borderRadius: 1,
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setCategoryModal(true);
            setModalOpen(true);
          }}
          sx={{
            backgroundColor: "#28A745",
            "&:hover": { backgroundColor: "#218838" },
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Add Category
        </Button>
      </Box>

      <Box>
        {isListingDataLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : null}
      </Box>
      {/* Vendor Table */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: "20px", p: 0, borderRadius: 2, boxShadow: 2 }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>S.no</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData && filteredData.length > 0 ? (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((vendor) => (
                  <TableRow key={vendor.category_id}>
                    <TableCell>{vendor.category_id}</TableCell>
                    <TableCell>
                      {/* {Array.isArray(vendor.category)
                    ? vendor.category.join(", ")
                    : vendor.category} */}
                      {vendor.name}
                    </TableCell>
                    <TableCell>
                      <Typography
                        color={vendor.status === 1 ? "green" : "gray"}
                        fontWeight={"bold"}
                      >
                        {vendor.status === 1 ? "Active" : "InActive"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {vendor.image_url ? (
                        <img
                          src={vendor.image_url}
                          alt="Category"
                          style={{ width: 50, height: 50, objectFit: "cover" }}
                        />
                      ) : (
                        <Typography>{vendor.image_url}</Typography>
                      )}
                    </TableCell>
                    <TableCell>{vendor.description}</TableCell>
                    <TableCell>
                      <IconButton onClick={(e) => handleMenuClick(e, vendor)}>
                        <MoreVert />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={
                          Boolean(anchorEl) &&
                          selectedVendor?.category_id === vendor.category_id
                        }
                        onClose={handleMenuClose}
                      >
                        <MenuItem
                          onClick={() => {
                            setFormValues({
                              category_id: selectedVendor.category_id,
                             
                              image_url: selectedVendor.image_url,
                              description: selectedVendor.description,
                              status: selectedVendor.status,
                              name: selectedVendor.name,
                            });
                            console.log(
                              "editclick",
                              formValues,
                              selectedVendor
                            );
                            setModalOpen(true);
                          }}
                        >
                          Edit
                        </MenuItem>
                        <MenuItem
                          sx={{ display: "none" }}
                          onClick={handleDelete}
                        >
                          Delete
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} style={{ textAlign: "center" }}>
                  No data found for the searched product.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={vendors && vendors.length ? vendors.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      {/* Modal */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: { xs: "calc(100vw - 24px)", sm: 400 },
      maxWidth: "100%",
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 4,
      maxHeight: "90vh",
      overflowY: "auto"
    }}
  >
    <Typography variant="h6" mb={2}>
      {selectedVendor ? "Edit Category" : "Add Category"}
    </Typography>

    <TextField
      fullWidth
      label="Category"
      variant="outlined"
      value={formValues.name}
      onChange={(e) =>
        setFormValues({ ...formValues, name: e.target.value })
      }
      error={!!categoryNameError}
      helperText={
        categoryNameError && (
          <Typography
            sx={{ textAlign: "left", color: "red" }}
          >
            {categoryNameError}
          </Typography>
        )
      }
      sx={{ mb: 2 }}
    />
    
    <TextField
      fullWidth
      label="Description"
      variant="outlined"
      value={formValues.description}
      onChange={(e) =>
        setFormValues({ ...formValues, description: e.target.value })
      }
      error={!!descriptionError}
      helperText={
        descriptionError && (
          <Typography
            sx={{ textAlign: "left", color: "red" }}
          >
            {descriptionError}
          </Typography>
        )
      }
      sx={{ mb: 2 }}
    />

    {/* Status should be visible only in Edit mode */}
    {selectedVendor && (
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={formValues.status || 0}
          onChange={(e) => {
            console.log("select", e.target.value);
            setFormValues((prev) => ({
              ...prev,
              status: e.target.value,
            }));
          }}
          label="Status"
        >
          <MenuItem value={1}>Active</MenuItem>
          <MenuItem value={0}>Deactive</MenuItem>
        </Select>
      </FormControl>
    )}
    
    <Box sx={{ mb: 2 }}>
      <Input
        type="file"
        fullWidth
        onChange={handleFileChange}
      />
    </Box>

    {/* Image preview with fixed height container */}
    <Box 
      sx={{ 
        mb: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: formValues.image_url ? "100px" : "auto",
        overflow: "hidden"
      }}
    >
      {formValues && formValues.image_url ? (
        <img
          src={formValues.image_url}
          alt="Category"
          style={{ 
            maxWidth: "100%", 
            maxHeight: "100px", 
            objectFit: "contain" 
          }}
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          No image selected
        </Typography>
      )}
    </Box>

    {/* Action buttons */}
    <Box sx={{ mt: 2 }}>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={selectedVendor ? handleEdit : handleAddCategory}
        sx={{ mb: 1 }}
      >
        {selectedVendor ? "UPDATE" : "Add"}
      </Button>

      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        onClick={handleCloseModal}
      >
        CLOSE
      </Button>
    </Box>
  </Box>
</Modal>
    </Box>
  );
}
